export default {
  title: 'Orc',
  content: ['Blood Fury: now also increases your spell damage and healing and ranged attack power.'],
}
